module.exports = __webpack_public_path__ + "static/media/rentabox_logo.fbe9aea1.png";